/**
 * 発注の手順の帯: ① 発注確定 → ② 入荷 → ③ 検品・シリアル → ④ 顧客へ発送 (2026-10-30〜)。
 */
import type { PurchaseOrderStatus } from '@goenhub/shared';

const STEP_LABELS = ['① 発注確定', '② 入荷', '③ 検品・シリアル', '④ 顧客へ発送'];

/** 状態ごとの「済んだ手順の数」(今の手順 = この番号)。 */
function doneSteps(status: PurchaseOrderStatus): number {
  switch (status) {
    case 'pending':
      return 0;
    case 'ordered':
      return 1;
    case 'received':
      return 2;
    case 'inspected':
      return 3;
    case 'shipped':
      return 4;
    default:
      return -1;
  }
}

/** ① 発注確定 → ② 入荷 → ③ 検品・シリアル → ④ 顧客へ発送 の進み具合。 */
export function FulfillmentSteps({ status }: { status: PurchaseOrderStatus }) {
  const done = doneSteps(status);
  if (done < 0) return null;
  return (
    <ol aria-label="発注から発送までの手順" className="grid grid-cols-2 sm:grid-cols-4 gap-1.5">
      {STEP_LABELS.map((label, i) => {
        const state = i < done ? 'done' : i === done ? 'current' : 'todo';
        return (
          <li
            key={label}
            aria-current={state === 'current' ? 'step' : undefined}
            className={`flex items-center gap-1.5 rounded-md border px-2 py-1 text-[11px] bg-[var(--bg-elevated)] ${
              state === 'done'
                ? 'border-[var(--accent-green)] text-[var(--text-primary)]'
                : state === 'current'
                  ? 'border-[var(--accent)] bg-[var(--accent-subtle)] font-semibold text-[var(--text-primary)]'
                  : 'border-[var(--border)] text-[var(--text-muted)]'
            }`}
          >
            <span
              className={`rounded-full px-1.5 text-[10px] font-semibold ${
                state === 'done'
                  ? 'bg-[var(--accent-green-subtle)] text-[var(--accent-green)]'
                  : state === 'current'
                    ? 'bg-[var(--accent-subtle)] text-[var(--accent)]'
                    : 'bg-[var(--bg-hover)] text-[var(--text-muted)]'
              }`}
            >
              {state === 'done' ? '✓' : state === 'current' ? '今' : '－'}
            </span>
            {label}
          </li>
        );
      })}
    </ol>
  );
}
